import { BaseContainerModel } from "../../base-container.model";
import { alg_bot_conversation_flow_RowClass } from "../../../dbschema";

export class BotCfContainerModel extends BaseContainerModel{
  alg_bot_conversation_flow: alg_bot_conversation_flow_RowClass = new alg_bot_conversation_flow_RowClass();
}
